module.exports = __webpack_public_path__ + "img/ydx-mobile@2x.49a9788e.png";